<template>
	<div class="row mt-4 align-self-center">
		<p class="f-12 align-self-center margin-0"><strong>Filter</strong></p>
		<div class="form-group col mr-2 ml-4">
			<select class="form-control" v-model="advanceFilter.type">
				<option value=1>Daily</option>
				<option value=2>Monthly</option>
				<option value=3>Yearly</option>
				<option value=4>Date Range</option>
			</select>
		</div>	

		<div class="form-group col mr-2 ml-4" v-if="advanceFilter.type == 1">
			<date-picker 
				v-model="advanceFilter.date" 
				placeholder="Choose Date" 
				style="width: 100%;" 
				format="MMMM D, YYYY" 
				value-type="YYYY-MM-DD">
			</date-picker>
		</div>

		<div class="form-group col mr-2 ml-4" v-if="advanceFilter.type == 2">
			<date-picker 
				v-model="advanceFilter.month" 
				type="month" 
				placeholder="Choose Month" 
				style="width: 100%;"
				format="MMMM YYYY" 
				value-type="YYYY-MM">
			</date-picker>
		</div>

		<div class="form-group col mr-2 ml-4" v-if="advanceFilter.type == 3">
			<date-picker 
				v-model="advanceFilter.year" 
				type="year" 
				placeholder="Choose Year" 
				style="width: 100%;" 
				value-type="YYYY">
			</date-picker>
		</div>
										
		<div class="form-group col mr-2 ml-4" v-if="advanceFilter.type == 4">
			<date-picker 
				v-model="advanceFilter.date_start" 
				placeholder="Choose Start Date" 
				style="width: 100%;" 
				format="MMMM D, YYYY" 
				value-type="YYYY-MM-DD">
			</date-picker>
		</div>
			
		<div class="form-group col ml-4 mr-2" v-if="advanceFilter.type == 4">
			<date-picker 
				v-model="advanceFilter.date_end" 
				placeholder="Choose End Date" 
				style="width: 100%;" 
				format="MMMM D, YYYY" 
				value-type="YYYY-MM-DD">
			</date-picker>
		</div>
		<a href="#" @click="reset()" class="link mr-5 ml-2" style="font-size:13px; margin-top:10px;">Reset</a>
	</div>
</template>
<script>
import { EventBus } from '@/plugins/bus.js'

export default {
	name: 'AdvanceFilter',
	data() {
		return {
			options: [],
			advanceFilter: {
				type		: 1,
				date		: this.$moment().format('YYYY-MM-DD'),
				month		: this.$moment().format('YYYY-MM'),
				year		: this.$moment().format('YYYY'),
				date_start	: this.$moment().format('YYYY-MM-DD'),
				date_end	: this.$moment().format('YYYY-MM-DD')
			}			
		}
	},
	methods: {
		reset(){
			let _ = this			

			_.advanceFilter = {
				type		: 1,
				date		: this.$moment().format('YYYY-MM-DD'),
				month		: this.$moment().format('YYYY-MM'),
				year		: this.$moment().format('YYYY'),
				date_start	: this.$moment().format('YYYY-MM-DD'),
				date_end	: this.$moment().format('YYYY-MM-DD')
			}

			EventBus.$emit('setAdvanceFilter', _.advanceFilter)
		}
	},
	watch: {
		"advanceFilter.type": function(){
			this.advanceFilter = {
				type		: this.advanceFilter.type,
				date		: this.$moment().format('YYYY-MM-DD'),
				month		: this.$moment().format('YYYY-MM'),
				year		: this.$moment().format('YYYY'),
				date_start	: this.$moment().format('YYYY-MM-DD'),
				date_end	: this.$moment().format('YYYY-MM-DD')
			}
			EventBus.$emit('setAdvanceFilter', this.advanceFilter)
		},
		"advanceFilter.date": function(){
			if (this.advanceFilter.date != ""){
				EventBus.$emit('setAdvanceFilter', this.advanceFilter)
			}
		},
		"advanceFilter.month": function(){
			if (this.advanceFilter.month != ""){
				EventBus.$emit('setAdvanceFilter', this.advanceFilter)
			}
		},
		"advanceFilter.year": function(){
			if (this.advanceFilter.year != ""){
				EventBus.$emit('setAdvanceFilter', this.advanceFilter)
			}
		},
		"advanceFilter.date_start": function(){
			if (this.advanceFilter.date_start != ""){
				EventBus.$emit('setAdvanceFilter', this.advanceFilter)
			}
		},
		"advanceFilter.date_end": function(){
			if (this.advanceFilter.date_end != ""){
				EventBus.$emit('setAdvanceFilter', this.advanceFilter)
			}
		}
	}
}
</script>